import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { ErrorBoundary } from '../components/ErrorBoundary';

/**
 * APP SHELL — Chrome dell'app nel nuovo design (port dal mockup):
 * frame > topbar (brand) + shell (rail auto-espandibile + contenuto).
 */
export function AppShell() {
  return (
    <div className="frame">
      <TopBar />
      <div className="shell">
        <Sidebar />
        <main className="main">
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </main>
      </div>
    </div>
  );
}
